import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as AtSvg } from './assets/at.svg';

const AtIcon = React.forwardRef((args, ref) => <SvgIcon component={AtSvg} ref={ref} {...args} />);

export default AtIcon;
